import { Link } from "wouter";
import { Navbar } from "@/components/Navbar";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

interface AuthLayoutProps {
  children: React.ReactNode;
  image?: string;
  title: string;
  subtitle: string;
}

export function AuthLayout({ children, image, title, subtitle }: AuthLayoutProps) {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      
      <div className="flex-1 flex flex-col md:flex-row">
        {/* Left Side - Form */}
        <div className="w-full md:w-1/2 lg:w-5/12 mx-auto flex flex-col justify-center px-6 py-12 lg:px-8">
          <div className="sm:mx-auto sm:w-full sm:max-w-md">
            <h1 className="text-3xl font-serif font-bold tracking-tight text-foreground text-center">
              {title}
            </h1>
            <p className="mt-2 text-center text-sm text-muted-foreground">
              {subtitle}
            </p>
          </div>

          <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
            {children}
          </div>
        </div>

        {/* Right Side - Image/Feature */}
        <div className="hidden md:flex md:w-1/2 lg:w-7/12 bg-muted relative overflow-hidden">
          {image ? (
            <img 
              src={image} 
              alt="Authentication Background" 
              className="absolute inset-0 h-full w-full object-cover"
            />
          ) : (
            <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-secondary/20 flex items-center justify-center p-12">
              <div className="max-w-lg text-center">
                <h2 className="text-4xl font-serif font-bold text-foreground mb-6">
                  {t('auth.welcomeMessage', 'Welcome to Listo')}
                </h2>
                <p className="text-lg text-muted-foreground">
                  {t('auth.platformDescription', 'The safest marketplace for buying, selling, and connecting with your community.')}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
